(function() {
  'use strict';

  angular.module('app').factory('GiftCardService', GiftCardService);

  GiftCardService.$inject = ['$rootScope', 'API', 'NotifyService'];

  function GiftCardService($rootScope, API, NotifyService) {
    var service = {};

    var _req_gc = ['GIFT_CARDS'];

    initVars();

    function initVars() {
      for (var i in _req_gc)
        $rootScope[_req_gc[i]] = {};
    }

    $rootScope.$on('user-login', function() {
      initVars();
    });

    $rootScope.$on('user-register', function() {
      initVars();
    });

    $rootScope.$on('user-logout', function() {
      for (var i in _req_gc)
        $rootScope[_req_gc[i]] = null;
    });

    service.All = function(params, callback) {
      var loyalty_id = params.loyalty;
      if ($rootScope.GIFT_CARDS[loyalty_id] &&
          $rootScope.GIFT_CARDS[loyalty_id].summary.page == params.page &&
          $rootScope.GIFT_CARDS[loyalty_id].summary.count == params.count &&
          $rootScope.GIFT_CARDS[loyalty_id].only_active == params.only_active) {
        callback(true, $rootScope.GIFT_CARDS[loyalty_id]);
      } else {
        API.get('/gift_cards?{0}'.format(paramsToUrlQueryEncodeURIComponent(params)), function(success, response) {
          if (success) {
            $rootScope.GIFT_CARDS[loyalty_id] = response;
            $rootScope.GIFT_CARDS[loyalty_id].summary.page = params.page;
            $rootScope.GIFT_CARDS[loyalty_id].summary.count = params.count;
            $rootScope.GIFT_CARDS[loyalty_id].only_active = params.only_active;
          }
          callback(success, response);
        });
      }
    };

    service.Get = function(id, callback) {
      API.get('/gift_cards/' + id, function(success, data) {
        if (success) {
        }
        callback(success, data);
      });
    };

    service.GetCoupons = function(post_data, callback) {
      API.post('/gift_cards/coupons', post_data, function(success, data) {
        if (success) {
        }
        callback(success, data);
      });
    };

    service.Create = function(post_data, callback) {
      API.post('/gift_cards', post_data, function(success, data) {
        if (success) {
          NotifyService.Success(data.message, false);

          if ($rootScope.GIFT_CARDS[data.loyalty_id] && $rootScope.GIFT_CARDS[data.loyalty_id].data)
            updateItemInList($rootScope.GIFT_CARDS[data.loyalty_id].data, data);
        }
        callback(success, data);
      });
    };

    service.Change = function(id, post_data, callback) {
      API.patch('/gift_cards/' + id, post_data, function(success, data) {
        if (success) {
          NotifyService.Success(data.message, false);

          if ($rootScope.GIFT_CARDS[data.loyalty_id] && $rootScope.GIFT_CARDS[data.loyalty_id].data)
            updateItemInList($rootScope.GIFT_CARDS[data.loyalty_id].data, data);
        }
        callback(success, data);
      });
    };

    service.UploadPhoto = function(id, data, callback) {
      API.postImage('/gift_cards/' + id + '/photo', data, function(success, response) {
        callback(success, response);
      });
    };

    return service;
  }

})();
